import { Card, Grid, Typography } from '@mui/material';
import React from 'react';
import { DashboardStyle } from '../Config/Style'

const Accordion = ({ data }) => {
    return (
        <Grid container spacing={3} columnGap={2} sx={DashboardStyle.accordionContainer}>
            {data.map((item, index) => (
                <Grid item key={index} xs={10} md={2.2} sx={DashboardStyle.accordionGridItem}>
                    <Card sx={DashboardStyle.accordionCard}>
                        <Typography variant="body1" fontWeight="bold">
                            {item.title}
                        </Typography>
                        <Typography variant="caption">{item.count}</Typography>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default Accordion;
